export default (theme) => ({
  cardBody: {
    background: theme.colorPalette.beige_25,
    width: '100%',
    margin: 0,
    padding: 24,
    borderRadius: '0 0 6px 6px'
  }
});
